/* eslint-disable react/require-default-props */
/* eslint-disable react/sort-comp */
// Default imports
import React from 'react';

// Spectrum
import ChevronLeft from '@spectrum-icons/workflow/ChevronLeft';
import ChevronRight from '@spectrum-icons/workflow/ChevronRight';

// Lodash
import _ from 'lodash';

// Styles
import './StepList.css';

// Only props this component accepts are children props.
interface ChildProps {
  children?: JSX.Element[];
}

// State interface
interface StepState {
  overflow: boolean;
  accordionOpen: boolean;
}

class StepList extends React.Component<ChildProps, StepState> {
  // Define the reference to our container.
  private stepContainerRef: React.RefObject<HTMLDivElement>;

  // Initialize state.
  constructor(props: ChildProps) {
    super(props);
    this.state = {
      overflow: false,
      accordionOpen: false,
    };
    // Ref to Step Container
    this.stepContainerRef = React.createRef();
  }

  componentDidMount(): void {
    // Listen for window resize.
    window.addEventListener(
      'resize',
      () => {
        // Detect if we are overflowing.
        this.detectOverflow();
      },
      true
    );
    // Run on initialization as well.
    this.detectOverflow();
  }

  /**
   * detectOverflow
   * Detects if our step container is overflowing, and sets the state accordingly.
   */
  detectOverflow = (): void => {
    // Get the reference.
    const container = _.get(this.stepContainerRef, 'current');
    // Get the current state.
    const { overflow } = this.state;

    // If our scroll width is greater than the client width
    if (container && container.scrollWidth > container.clientWidth) {
      // Set overflow to true if it isn't already.
      if (!overflow) {
        this.setState({
          overflow: true,
        });
      }
      // Otherwise set it to false.
    } else if (overflow) {
      this.setState({
        overflow: false,
      });
    }
  };

  /**
   * isOverflowing
   * @returns Boolean - whether we are overflowing or not.
   */
  isOverflowing = (): boolean => {
    const { overflow } = this.state;
    return overflow;
  };

  /**
   * scrollDiv
   * Scrolls the div in a specific direction on smaller screens.
   * @param direction - String "left" or "right" -
   */
  scrollDiv = (direction: string): void => {
    // Get the reference.
    const container = _.get(this.stepContainerRef, 'current');

    if (container && this.isOverflowing()) {
      switch (direction) {
        case 'right':
          container.scroll({
            left: container.scrollLeft + 150,
            behavior: 'smooth',
          });
          break;
        case 'left':
          container.scroll({
            left: container.scrollLeft - 150,
            behavior: 'smooth',
          });
          break;
        default:
          break;
      }
    }
  };

  // Render function.
  render() {
    const { children } = this.props;
    return (
      <div className='stepListContainer'>
        <div className='stepSection'>
          {this.isOverflowing() ? (
            <div
              className='arrow'
              role='button'
              tabIndex={0}
              onKeyDown={() => this.scrollDiv('left')}
              onClick={() => this.scrollDiv('left')}
            >
              <ChevronLeft size='L' />
            </div>
          ) : null}

          <div className='steps' ref={this.stepContainerRef}>
            {children}
          </div>

          {this.isOverflowing() ? (
            <div
              className='arrow'
              role='button'
              tabIndex={0}
              onKeyDown={() => this.scrollDiv('right')}
              onClick={() => this.scrollDiv('right')}
            >
              <ChevronRight size='L' />
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

export default StepList;
